import './DigitalEnvironment.scss'

import * as lottie_auth from '../../lotties/DigitalEnvironment/auth.json'
import * as lottie_mfa from '../../lotties/DigitalEnvironment/mfa.json'

import AddressBookComp from '../../components/AddressBook/AddressBook'
import { ReactComponent as Bluesky } from '../../icons/social/bluesky.svg'
import ChatNur from '../../components/Icons/ChatNur'
import Desplegable from '../../components/Desplegable/Desplegable'
import DidYouKnow from '../../components/DidYouKnow/DidYouKnow'
import ExternalLink from '../../components/ExternalLink/ExternalLink'
import { ReactComponent as Facebook } from '../../icons/social/facebook.svg'
import { ReactComponent as Flickr } from '../../icons/social/flickr.svg'
import FolderNur from '../../components/Icons/FolderNur'
import Href from '../../components/Href/Href'
import { ReactComponent as Instagram } from '../../icons/social/instagram.svg'
import { ReactComponent as Linkedin } from '../../icons/social/linkedin.svg'
import ListItem from '../../components/ListItem/ListItem'
import Lottie from 'react-lottie'
import { ModalContainer } from '../../components/Containers/ModalContainer'
import PeopleNur from '../../components/Icons/PeopleNur'
import { ReactComponent as Pinterest } from '../../icons/social/pinterest.svg'
import { SectionContainer } from '../../components/Containers/SectionContainer'
import SocialCard from '../../components/SocialCard/SocialCard'
import { ReactComponent as X } from '../../icons/social/x.svg'
import { ReactComponent as Youtube } from '../../icons/social/youtube.svg'
import { animated } from 'react-spring'
import { contacts } from '../../data'

const DigitalEnvironment = ({ color = 'dark-blue', secondary = 'green', scrollRight, modalHandling, closeModal, section, parallax, setLock }) => {
  // Lotties

  // https://lottiefiles.com/16763-animated-mail-illustration
  const lottieAuth = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_auth.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // https://lottiefiles.com/free-animation/reset-password-RJdgiDH3yN
  const lottieMFA = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_mfa.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // Desplegables area
  const digitalIdentity = (
    <div className="desplegable-container digital-identity">
      {lottieAuth}
      <ul className="kite-list">
        <li>
          <ListItem color={color} kiteColor={secondary}>
            <b>Autentificarte de manera segura</b> en todas las instituciones y organismos nacionales y europeos.
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            <b>Ser dueño/a de tu tiempo</b>, porque no estarás sujeto/a a los horarios de oficina para relacionarte con las administraciones públicas.
          </ListItem>
        </li>
        <li>
          <ListItem color={color} kiteColor={secondary}>
            <b>Evitar las colas y esperas que actualmente</b> requieren algunos servicios, ya que podrás realizar todos los trámites por Internet.
          </ListItem>
        </li>
      </ul>
      <p className="text-semi-normal bold bottom-text purple">Te avisaremos tan pronto como esté disponible, ¡estate al tanto!</p>
    </div>
  )

  const teamAdvantages = (
    <div className="desplegable-container teams-advantages">
      <p>Lo bueno de usar una herramienta como Teams es que puedes:</p>

      <div className="icon-group">
        <div className="icon-container">
          <PeopleNur size={30} color={secondary} />
        </div>
        <p>
          Pertenecer a <b>varios equipos</b>
        </p>
      </div>
      <div className="icon-group">
        <div className="icon-container">
          <ChatNur width={30} color={secondary} />
        </div>
        <p>
          <b>Crear canales</b> sobre diferentes temas
        </p>
      </div>
      <div className="icon-group">
        <div className="icon-container">
          <FolderNur width={30} color={secondary} />
        </div>
        <p>
          Dentro de cada uno de estos, <b>guardar las conversaciones</b>, archivos y grabaciones de reunión en un lugar organizado.
        </p>
      </div>
    </div>
  )

  const howToAccess = (
    <div className="desplegable-container how-to-access">
      <p>
        <b>Teams se encuentra incluido en el paquete Office 365</b>, al que tiene acceso todo el personal y estudiantado de la UAM, por lo que solo tienes que{' '}
        <b>iniciar sesión online con tu cuenta de estudiante</b> para utilizarlo en su versión de navegador o <b>descargar la app oficial</b>.
      </p>
      <div className="logos-container">
        <div className="img-container">
          <img src="/svg/icons/teams.png" alt="" />
        </div>
        <div className="right">
          <div className="img-container">
            <Href href="https://play.google.com/store/apps/details?id=com.microsoft.teams">
              <img src="/svg/logos/google-play.svg" alt="" />
            </Href>
          </div>
          <div className="img-container apple">
            <Href href="https://apps.apple.com/us/app/microsoft-teams/id1113153706">
              <img src="/svg/logos/apple-store.png" alt="" />
            </Href>
          </div>
        </div>
      </div>
      <p>
        En el caso de que el profesor o profesora de una asignatura utilice Teams, podréis chatear ante cualquier duda o necesidad.&nbsp;
        <b>Puedes acceder a Microsoft Teams con las credenciales de la UAM (cuenta de correo y contraseña).</b>
      </p>
    </div>
  )

  const socialUAM = (
    <>
      <SocialCard color={secondary} title="La UAM">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://es-es.facebook.com/universidadautonomademadrid">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/uammadrid/">Instagram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Bluesky style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://bsky.app/profile/uam.es">Bluesky</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Linkedin style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.linkedin.com/company/universidad-autonoma-de-madrid?trk=vsrp_companies_res_name&trkInfo=VSRPsearchId%3A904739271417556526931%2CVSRPtargetId%3A166613%2CVSRPcmpt%3Aprimary">
            LinkedIn (Empresa)
          </Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Linkedin style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.linkedin.com/edu/school?id=12194&trk=tyah&trkInfo=tarId%3A1416344610643%2Ctas%3Auniversidad%20aut%C3%B3noma%20de%20madrid%2Cidx%3A4-1-6">
            LinkedIn (Estudiantes)
          </Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/#!/uam_madrid">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/UAM">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Campus de excelencia internacional">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UamCsic">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/playlist?list=PL11E31D516AB1CDCF">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="AlumniUAM">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/alumniUAM">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/alumni_uam/">Instagram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Linkedin style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.linkedin.com/in/alumniuam">LinkedIn</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/AlumniUAM">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/user/AlumniUAM">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Fundación UAM (FUAM)">
        <div className="social-item">
          <i className="social-icon">
            <Linkedin style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.linkedin.com/company/2990979?trk=tyah&trkInfo=tarId%3A1416476624320%2Ctas%3Afundacion%20universidad%20auto%2Cidx%3A1-1-1">
            LinkedIn
          </Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/fuam_uam">X.com</Href>
        </div>
      </SocialCard>
    </>
  )

  const socialOffices = (
    <>
      <SocialCard color={secondary} title="Biblioteca y Archivo">
        <div className="social-item">
          <i className="social-icon">
            <Flickr style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.flickr.com/photos/uam_biblioteca">Flickr</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://instagram.com/uam_biblioteca/">Instagram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Pinterest style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.pinterest.com/UAM_Biblioteca/">Pinterest</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/uam.biblioteca/">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_Biblioteca">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/playlist?list=PL7D9B85F1C9708824">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Centro Cultural La Corrala / Museo Artes y Tradiciones Populares">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/MuseoATP">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/channel/UCs6AMiL3x7R24-NoUDqOqbA">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Centro Superior de Investigación y Promoción de la Música">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/CSIPM_UAM">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Centro de Iniciativas Emprendedoras (CIADE)">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/CIADE_UAM">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/user/CIADEUAM">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Colegio Mayor “Juan Luis Vives” ">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/cmluisvives">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/channel/UCYMm8v2huLxGvnbdikox6Og">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Oficina de Sostenibilidad UAM">
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/uamrenatura/">Instagram</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Ediciones UAM">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_EDICIONES">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/user/betocinio">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Empleabilidad (Oficina de Prácticas Externas y Orientación para el Empleo)">
        <div className="social-item">
          <i className="social-icon">
            <Linkedin style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.linkedin.com/company/166613?trk=edu-cp-sa-cname">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/OPEUAM">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Oficina de Acción solidaria y cooperación">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/ProgramaUAM">Discapacidad</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_Solidaria">Voluntariado</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Oficina de acogida">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_acogida">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Oficina de Actividades Culturales">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/OACUAM">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/oac_uam/">Instagram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_OAC">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="UAM Estudiantes">
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/uam_estudiantes/">Instagram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/uam_estudiantes">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Oficina de Proyectos Europeos e Internacionales">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/uamopei/">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/uam_opei/">Instagram </Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Linkedin style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://es.linkedin.com/in/uamopei">LinkedIn</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_OPEI">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/channel/UC8grlH1UyxCyiYWev8rzu7g">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Servicio de Educación Física y Deporte">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/pages/Servicio-de-Educaci%C3%B3n-F%C3%ADsica-y-Deporte-UAM/723774024367192?fref=ts">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/uam_deportes/">Instagram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/SEFyDUAM">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Servicio de Idiomas">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/pages/Servicio-de-Idiomas-UAM/1379785065677579?fref=ts">Facebook</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Unidad de Cultura Científica">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_Gazette">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Unidad de Igualdad de la UAM">
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_UIgualdadG">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/unidaddeigualdadUAM/">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/uig_uam/">Instagram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/user/unidaddeigualdadUAM">YouTube</Href>
        </div>
      </SocialCard>
    </>
  )

  const socialCenters = (
    <>
      <SocialCard color={secondary} title="Facultad de Ciencias">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/FacultadCienciasUAM">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/CienciasUAM?lang=es">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Facultad de Ciencias Económicas y Empresariales">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/facultadcienciaseconomicasuam">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/orieconomicasuam">Facebook Oficina de Relaciones Internacionales</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Instagram style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.instagram.com/uam_economicas/">Instragram</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_Economicas">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Facultad de Derecho">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/facultad.derecho.uam?fref=nf">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/derecho_uam">X.com</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/channel/UCmmQSFZPARiKEH8Q9I4fItQ">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Facultad de Filosofía y Letras">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/FyLUAM">Facebook</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/FyL_UAM">X.com</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Facultad de Formación de Profesorado y Educación">
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/channel/UCrjvYexd9U-zHWnLvQ10v2A">YouTube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Facultad de Medicina">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/aieme.uam?fref=ts">Facebook Asociación Internacional Estudiantes Medicina</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/postgrado.biociencias.moleculares">Facebook Posgrado en Biociencias Moleculares</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/trast_afectivos">Grupo de investigación (Dpto. Psiquiatría)</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_medicina">Medicina</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/UAM_Biosciences">Posgrado en Biociencias Moleculares</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <X style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://x.com/PosgradoFarma">Posgrado en Farmacología/Fisiología</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Facultad de Psicología">
        <div className="social-item">
          <i className="social-icon">
            <Facebook style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.facebook.com/ORI-Psicolog%C3%ADa-UAM-899741173421899/">Facebook de la Oficina de Relaciones Internacionales</Href>
        </div>
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/channel/UC-cLdB-fwGsQkMhLdZs3n_g">Youtube</Href>
        </div>
      </SocialCard>

      <SocialCard color={secondary} title="Escuela Politécnica Superior">
        <div className="social-item">
          <i className="social-icon">
            <Youtube style={{ fill: '#84BF41' }} />
          </i>
          <Href href="https://www.youtube.com/user/EPSUAMTeam">YouTube</Href>
        </div>
      </SocialCard>
    </>
  )

  // Modals area
  const mfa = (
    <ModalContainer secondary={secondary} color={color} title="Múltiple Factor de Autenticación (MFA)" onClick={() => closeModal()}>
      {lottieMFA}
      <p>
        <b>El MFA</b> es una medida que consiste en la introducción de una <b>segunda capa de seguridad</b> que complementa el uso de la contraseña, con el
        objetivo de que solo tú puedas usar tu <b>ID-UAM</b> para acceder a tus cuentas.
      </p>
      <p>
        Su uso es <b>obligatorio en la UAM</b> para poder acceder a varios recursos y aplicaciones académicas.
      </p>
      <p>Aprende cómo configurar el Múltiple Factor de Autenticación en el enlace inferior.</p>
      <ExternalLink
        color={secondary}
        secondary={color}
        url="https://www.uam.es/uam/tecnologias-informacion/servicios/multiple-factor-autenticacion"
        text="Configura el MFA UAM"
      />
    </ModalContainer>
  )

  const wifi = (
    <ModalContainer secondary={secondary} color={color} title="Conéctate a la red WiFi" onClick={() => closeModal()}>
      <p>
        Hay muchas cosas de tu vida en la UAM que necesitarás <b>gestionar online</b> y otras tantas para las que la Autónoma te ofrece recursos digitales que
        te facilitarán mucho la tarea. Es importante que te familiarices con estos entornos y herramientas para resolver de manera más eficiente las necesidades
        que vayan surgiendo.
      </p>

      <div className="wifi-image">
        <img src="/svg/front-pages/digital-environment/stay-connected.svg" alt="" />
      </div>

      <p>
        La UAM te proporciona <b>acceso gratuito a la red wifi EDUROAM</b>, a través de la que podrás conectarte a internet libremente, no solo en las
        instalaciones de la UAM, sino también en los campus de otras universidades españolas y extranjeras. Sigue las instrucciones que encontrarás en el
        siguiente enlace para conectar tus dispositivos:
      </p>

      <ExternalLink color={secondary} secondary={color} url="https://www.uam.es/uam/wifi" text="Pincha en la pestaña 'Documentación'" />
    </ModalContainer>
  )

  const moodle = (
    <ModalContainer secondary={secondary} color={color} title="Entra en el Moodle" onClick={() => closeModal()}>
      <p>
        La plataforma Moodle UAM <b>(moodle.uam.es)</b> es un <b>campus virtual</b> de apoyo a la docencia en el que tus profesoras y profesores colgarán
        materiales, abrirán espacios de entrega de tareas o subirán las notas de trabajos y exámenes. Usa el ID-UAM para acceder.
      </p>
      <ExternalLink url="https://moodle.uam.es/" color={secondary} secondary={color} />
      <ListItem color={color} kiteColor={secondary}>
        ¿Problemas para acceder?
        <b>
          <Href href="https://moodle.uam.es/mod/page/view.php?id=1775071"> ¡Consulta esta guía!</Href>
        </b>{' '}
      </ListItem>
      <DidYouKnow color={color}>
        <p>No podrás entrar hasta que hayan pasado 24/48 horas de la activación de tu cuenta de correo.</p>
      </DidYouKnow>
    </ModalContainer>
  )

  const sigma = (
    <ModalContainer secondary={secondary} color={color} title="Añade Sigma a tus favoritos" onClick={() => closeModal()}>
      <p>
        SIGMA es la <b>secretaría virtual de la UAM</b>, la plataforma de gestión académica en la que hiciste tu matrícula. En ella podrás{' '}
        <b>consultar y tramitar</b> todo lo relativo a tu <b>expediente académico</b> (tus calificaciones, la nota media o los créditos superados), así que{' '}
        <b>¡no la pierdas de vista!</b>
      </p>

      <div className="sigma-container">
        <img src="/svg/front-pages/digital-environment/sigma.svg" alt="" />
      </div>

      <AddressBookComp color={color} data={contacts['secretaria-virtual']} />
    </ModalContainer>
  )

  const electronicHost = (
    <ModalContainer secondary={secondary} color={color} title="Añade Sigma a tus favoritos" onClick={() => closeModal()}>
      <p>
        Además de <b>SIGMA</b>, la Universidad también dispone de una <b>sede administrativa electrónica</b> donde puedes encontrar información sobre el resto
        de trámites relevantes y realizar solicitudes por vía telemática.
      </p>
      <p>
        La Sede Electrónica es el lugar dónde podrás solicitar permanencia o convocatoria excepcional, dirigirte a la Defensoría Universitaria o visitar su
        Tablón para consultar resoluciones o convocatorias, entre otros <b>trámites</b> de los que te daremos más información en esta guía.
      </p>
      <p>
        Para algunas gestiones en la Sede Electrónica necesitarás disponer de un <b>certificado o firma digital que posibilite acreditar tu identidad</b> de
        manera segura en plataformas virtuales.
      </p>
      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Nueva identidad digital propia de la UAM">
          {digitalIdentity}
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const freeSoftware = (
    <ModalContainer secondary={secondary} color={color} title="Software gratuito" onClick={() => closeModal()}>
      <p>
        Los estudiantes de la UAM pueden acceder a la descarga gratuita del paquete de aplicaciones <b>Microsoft Office 365</b>, que incluye Word, PowerPoint,
        Excel y otras herramientas muy útiles.
      </p>
      <div className="img-container monitor">
        <img src="/svg/icons/monitor-office.svg" alt="" />
      </div>
      <p className={`text-semi-normal bold colored ${secondary}`}>¡Aprovecha y sácale partido!</p>
      <p>Te resultará mucho más fácil avanzar en cualquier proyecto.</p>
      <ExternalLink
        text="Accede para saber cómo descargar y configurar las aplicaciones."
        url="https://faq.uam.es/index.php?action=artikel&cat=12&id=14&artlang=es"
        color={secondary}
        secondary={color}
      />
    </ModalContainer>
  )

  const onlineTeaching = (
    <ModalContainer secondary={secondary} color={color} title="Docencia Online en Teams" onClick={() => closeModal()}>
      <p>
        El <b>entorno de trabajo online</b> que utilizamos en la <b>UAM</b> incluye, además de Moodle, otras herramientas como <b>Teams</b>, que permiten a tus
        profesores y profesoras llevar a cabo clases a distancia, tutorías o diferentes tareas si lo consideran necesario. También puedes utilizarlas para
        realizar <b>videoconferencias y compartir documentos</b> con grupos de compañeros o compañeras y realizar de manera colaborativa los trabajos en equipo
        que el profesorado os pide.
      </p>
      <div className="img-container online-teaching-image">
        <img src="/svg/icons/online-teaching.svg" alt="" />
      </div>
      <DidYouKnow color={color}>
        <p>
          Con el objetivo de facilitar el seguimiento adecuado de la docencia para estudiantes que puedan estar en una situación económica desfavorable, la
          Universidad Autónoma dispone de un programa de <b>préstamo de material informático</b> como ordenadores portátiles o cámaras web. Esta convocatoria
          está abierta durante gran parte del año académico, consúltala en la web si en algún momento te encuentras en una situación que lo requiera.
        </p>
      </DidYouKnow>
      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Ventajas de Teams">
          {teamAdvantages}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Cómo acceder">
          {howToAccess}
        </Desplegable>
        <AddressBookComp color={color} data={contacts['docencia-digital-uam']} />
      </div>
    </ModalContainer>
  )

  const vpnAcccess = (
    <ModalContainer secondary={secondary} color={color} title="Accede mediante VPN (Virtual Private Network)" onClick={() => closeModal()}>
      <p>
        Algunas <b>aplicaciones y servicios de red</b> están sólo disponibles para los miembros de la <b>comunidad Universitaria</b> (antivirus institucional,
        acceso a Bases de Datos y Revistas del Servicio de Bibliotecas, etc...). El acceso a estos recursos sólo se permite desde la <b>red de la UAM</b>, pero
        no desde cualquier otra parte de Internet (la red de otra Universidad, tu domicilio, etc.). Si en algún momento necesitas acceder a algunos de los
        recursos restringidos fuera del campus, puedes instalar la <Href href="https://vpn.uam.es/">VPN (vpn.uam.es)</Href> y <b>autenticarte con el ID-UAM</b>{' '}
        para conectarte como si estuvieses en la Autónoma.
      </p>
      <p>
        Para este tipo de acceso, será necesario que hayas configurado previamente el <b>Múltiple Factor de Autenticación</b> (revisa el punto 1) y así
        garantizar que el acceso no se produce de una manera fraudulenta.
      </p>
      <ExternalLink text="Acceso a la VPN UAM" url="https://vpn.uam.es/" color={secondary} secondary={color} />
      <div className="img-container vpn">
        <img src="/svg/icons/vpn.svg" alt="" />
      </div>
    </ModalContainer>
  )

  const uamApp = (
    <ModalContainer secondary={secondary} color={color} title="Descubre la app de la UAM" onClick={() => closeModal()}>
      <p>
        Disponible para <b>iOS y Android</b>, podrás conocer todas las <b>novedades de la Universidad</b> o tener un <b>carné digital</b> siempre a mano para la
        biblio, además de consultar tus <b>notas</b>, la agenda semanal de <b>actividades</b>, la <b>oferta académica, becas y ayudas</b> al estudio, los menús
        de las cafeterías y las direcciones de contacto de los principales servicios de la Universidad. Descarga la app y lleva siempre toda la información en
        el bolsillo.
      </p>
      <div className="logos-container-apps">
        <div className="img-container">
          <img src="/svg/logos/logo-square-uam.svg" alt="" />
        </div>
        <div className="right-logos">
          <div className="img-container">
            <Href href="https://play.google.com/store/apps/details?id=net.universia.uam">
              <img src="/svg/logos/google-play.svg" alt="" />
            </Href>
          </div>
          <div className="img-container">
            <Href href="https://apps.apple.com/es/app/universidad-aut%C3%B3noma-de-madrid/id1272096838">
              <img src="/svg/logos/app-store.svg" alt="" />
            </Href>
          </div>
        </div>
      </div>
    </ModalContainer>
  )

  const social = (
    <ModalContainer secondary={secondary} color={color} title="Encuentranos en nuestras redes sociales" onClick={() => closeModal()}>
      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="Redes sociales UAM">
          {socialUAM}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Oficinas y Servicios Centrales">
          {socialOffices}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="Centros (Facultades y EPS)">
          {socialCenters}
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const items = [
    { key: 'mfa', content: mfa, title: 'Múltiple Factor de Autenticación (MFA)' },
    { key: 'wifi', content: wifi, title: 'Conéctate a la red wifi' },
    { key: 'moodle', content: moodle, title: 'Entra en Moodle' },
    { key: 'sigma', content: sigma, title: 'Añade Sigma a tus favoritos' },
    { key: 'electronic-host', content: electronicHost, title: 'Sede electrónica' },
    { key: 'free-software', content: freeSoftware, title: 'Software gratuito' },
    { key: 'online-teaching', content: onlineTeaching, title: 'Docencia online en Teams' },
    { key: 'vpn-access', content: vpnAcccess, title: 'Accede mediante VPN' },
    { key: 'uam-app', content: uamApp, title: 'Descubre la app de la UAM' },
    { key: 'social', content: social, title: 'Redes sociales UAM' }
  ]

  const Splash = (
    <>
      <div className="logo-back">
        <img src="/splash/svg/DigitalEnvironment_logo_back.svg" alt="" />
      </div>
      <animated.div className="logo-main" style={{ transform: parallax.logo_main(section) }}>
        <img src="/splash/svg/DigitalEnvironment_logo_main.svg" className="illustration" alt="" />
        <img src="/splash/png/DigitalEnvironment.png" className="image" alt="" />
      </animated.div>
      <div className="logo-front">
        <img src="/splash/svg/DigitalEnvironment_logo_front.svg" alt="" />
      </div>
    </>
  )

  return (
    <SectionContainer
      // Section
      className={'DigitalEnvironment'}
      title={'Configura tu entorno digital'}
      // General
      color={color}
      secondary={secondary}
      items={items}
      setLock={setLock}
      section={section}
      // Mobile
      handleMobileModal={modalHandling}
      scrollRight={scrollRight}
    >
      {Splash}
    </SectionContainer>
  )
}

export default DigitalEnvironment
